import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { User } from '@models/swagger';
import { GetUserByIdParams } from './service';

export enum GetUserByIdActions {
  Failure = '[Application Utilities GetUserById] Failure',
  Request = '[Application Utilities GetUserById] Request',
  Success = '[Application Utilities GetUserById] Success',
}

export const GetUserByIdFailure = createAction(GetUserByIdActions.Failure, props<{ error: HttpErrorResponse }>());

export const GetUserByIdRequest = createAction(GetUserByIdActions.Request, props<{ parameters: GetUserByIdParams }>());

export const GetUserByIdSuccess = createAction(GetUserByIdActions.Success, props<{ data: User }>());
